package com.neurobs.ccab

trait DataSyncStateSourceSubscriber
{
	def onNewState(state: DataSyncState): Unit
}

abstract class DataSyncStateSource
{
	private var state: DataSyncState = DataSyncState(Seq(), false, 0, false)
	private var subscriber: DataSyncStateSourceSubscriber = (_: DataSyncState) => {}

	def getState(): DataSyncState = state

	def applyUpdate(update: DataSyncStateData): Unit = {
		state = state.applyUpdate(update)
		subscriber.onNewState(state)
	}

	def setVisible(visible: Boolean): Unit = {
		state = state.copy(visible = visible)
		subscriber.onNewState(state)
	}

	def setSubscriber(sub: DataSyncStateSourceSubscriber): Unit = {
		subscriber = sub
	}

	def requestUpdate(reset: Boolean): Unit

	def setPaused(paused: Boolean): Unit

	def addBacklog(): Unit
}

case class DataSyncState
(
	requests: Seq[SyncRequestStatus],
	paused: Boolean,
	backlogCount: Int,
	visible: Boolean
)
{
	/** If everything is currently up to date */
	lazy val complete: Boolean = {
		(backlogCount == 0) && requests.forall(_.finished())
	}

	/** Number of requests not done */
	lazy val pending: Int = {
		requests.count(!_.finished()) + backlogCount
	}

	/** Returns current state with the update applied */
	def applyUpdate(update: DataSyncStateData): DataSyncState = {
		if (update.reset) DataSyncState(
			requests = update.requests,
			paused = update.paused,
			backlogCount = update.backlog_count,
			visible = visible
		)
		else {
			val changed = requests map { r =>
				update.requests.find(_.file == r.file) match {
					case None => r
					case Some(n) => n
				}
			}
			val extras = update.requests.filter(r => !requests.exists(_.file == r.file))
			DataSyncState(
				requests = changed ++ extras,
				paused = update.paused,
				backlogCount = update.backlog_count,
				visible = visible
			)
		}
	}
}
